import { __assign } from 'tslib';
import { baseTheme } from './defaultToolkitTheme.js';

// Whiskymofo specific colors
var whiskyColors = {
  whiskyGold: "#F3B659",
  goldLantern: "#FF9B4B",
  whiskyBrand: "#FF9B4B"
};
var wmTheme = __assign(__assign({}, baseTheme), {
  name: "whiskymofo",
  colors: __assign(__assign(__assign({}, baseTheme.colors), {
    brand: baseTheme.colors.mofoGreen,
    mofoBrand: whiskyColors.whiskyBrand,
    primary: baseTheme.colors.greenLantern,
    mofoPrimary: whiskyColors.whiskyGold,
    secondary: baseTheme.colors.vader,
    mofoSecondary: baseTheme.colors.vader
  }), whiskyColors)
});

export { wmTheme };
//# sourceMappingURL=wmTheme.js.map
